import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { trackEvent } from '../hooks/useMetaPixel';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  size?: 'normal' | 'large';
  showTrust?: boolean;
}
export function CTAButton({
  text,
  subtext,
  size = 'normal',
  showTrust = true
}: CTAButtonProps) {
  const isLarge = size === 'large';
  const handleClick = () => {
    trackEvent('InitiateCheckout', {
      content_name: 'Protocolo 24H: Salto Cuántico',
      content_category: 'Digital Product',
      value: 19990,
      currency: 'ARS'
    });
  };
  return <div className="flex flex-col items-center gap-4" data-id="element-38">
      <motion.a href="https://guiadigital360.online/cart/44311902650461:1" target="_blank" rel="noopener noreferrer" onClick={handleClick} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.98
    }} className={`
          inline-block text-center font-body font-bold uppercase tracking-wide
          bg-brand-gold text-[#0A0A0A] rounded-lg
          transition-shadow duration-300
          hover:bg-brand-gold-light hover:shadow-[0_0_40px_rgba(212,175,55,0.5)]
          shadow-[0_0_20px_rgba(212,175,55,0.25)]
          ${isLarge ? 'px-10 py-5 text-lg md:text-xl' : 'px-8 py-4 text-base md:text-lg'}
        `} data-id="element-39">
        {text}
      </motion.a>
      {subtext && <p className="text-brand-muted text-sm italic" data-id="element-40">{subtext}</p>}
      {showTrust && <p className="text-brand-muted-dark text-xs tracking-wide flex items-center justify-center gap-1 flex-wrap" data-id="element-41">
          <LockIcon className="w-3 h-3 inline" data-id="element-42" /> Pago seguro por MercadoPago ·
          ✓ Descarga en 5 minutos · ✓ Garantía 7 días · ✓ 390 páginas
        </p>}
    </div>;
}